import { responsiveFontSizes } from "@mui/material";
import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    defaultTheme: Palette["primary"];
  }

  interface PaletteOptions {
    defaultTheme?: PaletteOptions["primary"];
  }

  interface Theme {
    logo: string;
    sharebg: string;
    uploadBoxBg: string;
    uploadBoxBorderColor: string;
  }

  interface ThemeOptions {
    logo?: string;
    sharebg?: string;
    uploadBoxBg: string;
    uploadBoxBorderColor: string;
  }
}

const bumaStemraThemePalette = responsiveFontSizes(createTheme({
  logo: "/assets/images/logo.png",
  sharebg: "rgba(17, 17, 187, 1)",
  uploadBoxBg: "rgba(244, 247, 254, 1)",
  uploadBoxBorderColor: "rgba(115, 186, 252, 1)",
  typography: {
    fontFamily: "Inter",
    fontSize: 14,
  },
  palette: {
    mode: "light",
    primary: {
      main: "rgba(17, 17, 187, 1)",

    },
    secondary: {
      main: "rgba(222, 237, 251, 1)",
    },
    tonalOffset: {
      light: 0.2,
      dark: 0.1,
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "rgba(92, 92, 111, 1)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 5,
          // padding: "10px 15px",
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedSecondary: {
          color: "rgba(17, 17, 187, 1)",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            '& fieldset.MuiOutlinedInput-notchedOutline': {
              borderWidth: 1,
            }
          }
        }
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        focused: true,
        InputLabelProps: {
          shrink: true,
          style: { color: "rgba(92, 92, 111, 1)" },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: "small",
        focused: true
      },
    },
    MuiSelect: {
      defaultProps: {

      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          color: "rgba(17, 17, 187, 1)",
          fontWeight: 600,
        },
      },
    }
  }
}));

const bumaStemraTheme = {
  theme: bumaStemraThemePalette,
  logo: "/assets/images/logo.png",
  sharebg: "rgba(17, 17, 187, 1)",
  name: "BumaStemra",
  defaultLanguage: "nl",
  avatarColor: "#11AA99"
};

const cpdThemePalette = responsiveFontSizes(createTheme({
  logo: "/assets/images/cpd-logo.png",
  sharebg: "/assets/images/alternate_background.png",
  uploadBoxBg: "rgba(151, 71, 255, 0.05)",
  uploadBoxBorderColor: "rgba(151, 71, 255, 0.3)",
  typography: {
    fontFamily: "Manrope",
  },
  palette: {
    mode: "light",
    primary: {
      main: "rgba(108, 46, 211, 1)",
    },
    secondary: {
      main: "rgba(243, 245, 255, 1)",
    },
    tonalOffset: {
      light: 0.2,
      dark: 0.1,
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "rgba(15,23,42, 0.9)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 10,
          // padding: "10px 15px",
          textTransform: "capitalize",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedSecondary: {
          color: "rgba(108, 46, 211, 1)",
        },
      },
    },
  },
}));

const cpdTheme = {
  theme: cpdThemePalette,
  logo: "/assets/svg/logo.svg",
  sharebg: "/assets/images/alternate_background.png",
  name: "Copyright Delta",
  defaultLanguage: "en",
};

const demoThemePalette = responsiveFontSizes(createTheme({
  logo: "/assets/images/demo-logo.png",
  sharebg: "/assets/images/externalShare.png",
  uploadBoxBg: "rgba(244, 247, 254, 1)",
  uploadBoxBorderColor: "rgba(115, 186, 252, 1)",
  typography: {
    fontFamily: "Inter",
    fontSize: 14,
  },
  palette: {
    mode: "light",
    primary: {
      main: "rgba(17, 17, 187, 1)",

    },
    secondary: {
      main: "rgba(222, 237, 251, 1)",
    },
    tonalOffset: {
      light: 0.2,
      dark: 0.1,
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "rgba(92, 92, 111, 1)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 5,
          // padding: "10px 15px",
          textTransform: "capitalize",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedSecondary: {
          color: "rgba(17, 17, 187, 1)",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            '& fieldset.MuiOutlinedInput-notchedOutline': {
              borderWidth: 1,
            }
          }
        }
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        focused: true,
        InputLabelProps: {
          shrink: true,
          style: { color: "rgba(92, 92, 111, 1)" },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: "small",
        focused: true
      },
    },
    MuiSelect: {
      defaultProps: {

      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          color: "rgba(17, 17, 187, 1)",
          fontWeight: 600,
        },
      },
    }
  }
}));

const demoTheme = {
  theme: demoThemePalette,
  logo: "/assets/images/demo-logo.png",
  sharebg: "/assets/images/externalShare.png",
  name: "Demo",
  defaultLanguage: "en"
};


export const themes = {
  BUMASTEMRA: bumaStemraTheme,
  COPYRIGHTDELTA: cpdTheme,
  DEFAULT: bumaStemraTheme,
  DEMO: demoTheme,
  // Local/dev only: reuses the demo look, but its tenant id ("local") resolves
  // to the group-mode CachingDefaultGroupHandler on the web-service, so the
  // profile membership + cache-bust flow can be tested without the Buma env.
  LOCAL: demoTheme
};
